/**
 * Brand compliance programmes Atlas serves, keyed by `compliance.programs.key`.
 *
 * Each programme has its OWN permission entity (never a shared
 * `compliance:*`), because a brand's customer org is granted its programme and
 * must never reach another brand's. Adding a programme = a row in
 * `compliance.programs`, a permission block and a data-tables entry in
 * wv-db-schemas, and an entry here (moving it out of PLANNED); the Compliance
 * nav group and the route pick it up.
 */
const COMPLIANCE_PROGRAMS = {
  choice_hsia: {
    key: 'choice_hsia',
    /** Route segment: /internal/compliance/<slug>. */
    slug: 'choice-hsia',
    entity: 'compliance:choice-hsia',
    /** data-tables registry id; gates the hotel list's Export. */
    tableId: 'internal:compliance-choice-hsia',
    /** data-tables registry id for the Hotel claims queue. */
    claimsTableId: 'internal:compliance-choice-hsia-claims',
    /** data-tables registry id for the self-report review queue. */
    reviewTableId: 'internal:compliance-choice-hsia-review',
    /** data-tables registry id for the hotels set aside from the programme. */
    setAsideTableId: 'internal:compliance-choice-hsia-set-aside',
    /** data-tables registry id for a month close's results. */
    periodResultsTableId: 'internal:compliance-choice-hsia-period-results',
    /** First month Atlas reviews self-reports for: the queue and the close
     * leave earlier months (Control Panel's backlog) alone. */
    reviewFrom: '2026-10-01',
    /** Report engine id of the month a close sends (reports.config.ts). */
    monthlyReportId: 'choice-hsia-monthly',
    brand: 'Choice Hotels',
    /** The brand in running copy ("Choice HSIA reporting"). */
    shortBrand: 'Choice',
    standard: 'HSIA'
  }
} as const

/**
 * Seeded inactive in `compliance.programs`, shown in the nav as planned so
 * staff can see where they will land. One list, so a programme cannot be
 * both live and planned once it moves up into COMPLIANCE_PROGRAMS.
 */
export const PLANNED_COMPLIANCE_PROGRAMS = [
  { key: 'marriott_gpns', brand: 'Marriott', standard: 'GPNS' },
  { key: 'hilton_unonet', brand: 'Hilton', standard: 'UnoNet' }
] as const satisfies readonly {
  key: string
  brand: string
  standard: string
}[]

export type ComplianceProgramKey = keyof typeof COMPLIANCE_PROGRAMS
export type ComplianceProgram =
  (typeof COMPLIANCE_PROGRAMS)[ComplianceProgramKey]

export const complianceProgramList = (): ComplianceProgram[] =>
  Object.values(COMPLIANCE_PROGRAMS)

export const complianceProgramBySlug = (
  slug: string
): ComplianceProgram | undefined =>
  complianceProgramList().find((p) => p.slug === slug)
